<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <!-- 内嵌表单模式 -->
        <check-enter-modal v-if="showForm" ref="modalForm" :formMode="formMode" @ok="modalFormOk" @cancel="modalFormClose"></check-enter-modal>
        <!-- 列表模式 -->
        <template v-if="!showForm">
          <!-- 查询区域 -->
          <div class="table-page-search-wrapper">
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :md="6" :sm="24">
                  <a-form-item label="单据编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入单据编号" v-model="queryParam.number"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="商品信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入条码、名称、助记码、规格、型号等信息" v-model="queryParam.materialParam"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="单据日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-range-picker
                      style="width:100%"
                      v-model="queryParam.createTimeRange"
                      format="YYYY-MM-DD"
                      :placeholder="['开始时间', '结束时间']"
                      @change="onDateChange"
                    />
                  </a-form-item>
                </a-col>
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-col :md="6" :sm="24">
                    <a-button type="primary" @click="searchQuery">查询</a-button>
                    <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                    <a @click="handleToggleSearch" style="margin-left: 8px">
                      {{ toggleSearchStatus ? '收起' : '展开' }}
                      <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                    </a>
                  </a-col>
                </span>
              </a-row>
              <template v-if="toggleSearchStatus">
                <a-row :gutter="24">
                  <a-col :md="6" :sm="24">
                    <a-form-item label="仓库名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select placeholder="请选择仓库" showSearch allow-clear optionFilterProp="children" v-model="queryParam.depotId">
                        <a-select-option v-for="(depot,index) in depotList" :key="index" :value="depot.id">
                          {{ depot.depotName }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="操作员" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select placeholder="请选择操作员" showSearch allow-clear optionFilterProp="children" v-model="queryParam.creator">
                        <a-select-option v-for="(item,index) in userList" :key="index" :value="item.id">
                          {{ item.userName }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="单据状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select placeholder="请选择单据状态" allow-clear v-model="queryParam.status">
                        <a-select-option value="0">未审核</a-select-option>
                        <a-select-option value="9" v-if="!checkFlag">审核中</a-select-option>
                        <a-select-option value="1">已审核</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="单据备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input placeholder="请输入单据备注" v-model="queryParam.remark"></a-input>
                    </a-form-item>
                  </a-col>
                </a-row>
              </template>
            </a-form>
          </div>
          <!-- 操作按钮区域 -->
          <div class="table-operator" style="margin-top: 5px">
            <a-button v-if="btnEnableList.indexOf(1)>-1" @click="myHandleAdd" type="primary" icon="plus">新增</a-button>
            <a-button v-if="btnEnableList.indexOf(1)>-1" icon="delete" @click="batchDel">删除</a-button>
            <a-button v-if="checkFlag && btnEnableList.indexOf(2)>-1" icon="check" @click="batchSetStatus(1)">审核</a-button>
            <a-button v-if="checkFlag && btnEnableList.indexOf(7)>-1" icon="stop" @click="batchSetStatus(0)">反审核</a-button>
            <a-button v-if="isShowExcel && btnEnableList.indexOf(3)>-1" icon="download" @click="handleExport">导出</a-button>
            <a-popover trigger="click" placement="right">
              <template slot="content">
                <a-checkbox-group @change="onColChange" v-model="settingDataIndex" :defaultValue="settingDataIndex">
                  <a-row style="width: 500px">
                    <template v-for="(item,index) in defColumns">
                      <template v-if="item.dataIndex!='action'">
                        <a-col :span="8">
                          <a-checkbox :value="item.dataIndex">
                            <j-ellipsis :value="item.title" :length="10"></j-ellipsis>
                          </a-checkbox>
                        </a-col>
                      </template>
                    </template>
                  </a-row>
                  <a-row style="padding-top: 10px;">
                    <a-col>
                      恢复默认列配置：<a-button @click="handleRestDefault" type="link" size="small">恢复默认</a-button>
                    </a-col>
                  </a-row>
                </a-checkbox-group>
              </template>
              <a-button icon="setting">列设置</a-button>
            </a-popover>
            <a-button v-if="btnEnableList.indexOf(1)>-1" icon="share-alt" @click="handleTransferToReplay">转盘点复盘</a-button>
          </div>
          <!-- table区域 -->
          <div>
            <a-table
              ref="table"
              size="middle"
              bordered
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :scroll="scroll"
              :loading="loading"
              :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
              :expandedRowKeys="expandedRowKeys"
              @expand="onExpand"
              @change="handleTableChange">
              <span slot="action" slot-scope="text, record">
                <a @click="myHandleDetail(record, '盘点录入', prefixNo)">查看</a>
                <a-divider v-if="btnEnableList.indexOf(1)>-1" type="vertical" />
                <a v-if="btnEnableList.indexOf(1)>-1" @click="myHandleEdit(record)">编辑</a>
                <a-divider v-if="btnEnableList.indexOf(1)>-1" type="vertical" />
                <a v-if="btnEnableList.indexOf(1)>-1" @click="myHandleCopyAdd(record)">复制</a>
                <a-divider v-if="btnEnableList.indexOf(1)>-1" type="vertical" />
                <a-popconfirm v-if="btnEnableList.indexOf(1)>-1" title="确定删除吗?" @confirm="() => myHandleDelete(record)">
                  <a>删除</a>
                </a-popconfirm>
              </span>
              <template slot="customRenderStatus" slot-scope="status">
                <a-tag v-if="status == '0'" color="red">未审核</a-tag>
                <a-tag v-if="status == '1'" color="green">已审核</a-tag>
                <a-tag v-if="status == '9'" color="orange">审核中</a-tag>
              </template>
              <a-table
                bordered
                size="small"
                slot="expandedRowRender"
                slot-scope="record"
                :loading="record.loading"
                :columns="detailColumns"
                :dataSource="record.childrens"
                :row-key="record => record.id"
                :pagination="false">
              </a-table>
            </a-table>
          </div>
        </template>
        <!-- 弹窗组件（导出等） -->
        <bill-excel-iframe ref="billExcelIframe" @ok="modalFormOk" @close="modalFormClose"></bill-excel-iframe>
        <bill-detail ref="modalDetail" @ok="modalFormOk" @close="modalFormClose"></bill-detail>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
  import CheckEnterModal from './CheckEnterModal'
  import BillExcelIframe from '@/components/tools/BillExcelIframe'
import BillDetail from '@/views/bill/dialog/BillDetail'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { BillListMixin } from '@/views/bill/mixins/BillListMixin'
  import JEllipsis from '@/components/jeecg/JEllipsis'
  import { deleteAction } from '@/api/manage'
  export default {
    name: "CheckEnterList",
    mixins: [JeecgListMixin, BillListMixin],
    components: {
      CheckEnterModal,
      BillExcelIframe,
      BillDetail,
      JEllipsis
    },
    data () {
      return {
        queryParam: {
          number: "",
          materialParam: "",
          type: "其它",
          subType: "盘点录入",
          depotId: undefined,
          creator: undefined,
          status: undefined,
          remark: ""
        },
        prefixNo: 'PDLR',
        urlPath: '/plugins/stockCheck/stockCheckEnter',
        showForm: false,
        formMode: 'add',
        inOutManageFlag: false,
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 18,
          offset: 1
        },
        defDataIndex: ['action', 'number', 'materialsList', 'operTimeStr', 'userName', 'materialCount', 'totalPrice', 'status'],
        defColumns: [
          {
            title: '操作',
            dataIndex: 'action',
            align: "center", width: 160,
            scopedSlots: { customRender: 'action' },
          },
          { title: '单据编号', dataIndex: 'number', width: 160 },
          { title: '商品信息', dataIndex: 'materialsList', width: 220, ellipsis: true },
          { title: '单据日期', dataIndex: 'operTimeStr', width: 145 },
          { title: '操作员', dataIndex: 'userName', width: 80, ellipsis: true },
          { title: '数量', dataIndex: 'materialCount', width: 60 },
          { title: '金额合计', dataIndex: 'totalPrice', width: 80 },
          { title: '备注', dataIndex: 'remark', width: 200 },
          { title: '状态', dataIndex: 'status', width: 80, align: "center",
            scopedSlots: { customRender: 'customRenderStatus' }
          }
        ],
        url: {
          list: "/depotHead/list",
          delete: "/depotHead/delete",
          deleteBatch: "/depotHead/deleteBatch",
          batchSetStatusUrl: "/depotHead/batchSetStatus"
        }
      }
    },
    created() {
      this.initSystemConfig()
      this.getDepotData()
      this.initUser()
    },
    methods: {
      myHandleAdd() {
        this.formMode = 'add'
        this.showForm = true
        this.$nextTick(() => {
          this.$refs.modalForm.action = 'add'
          this.$refs.modalForm.add()
        })
      },
      myHandleEdit(record) {
        this.formMode = 'edit'
        this.showForm = true
        this.$nextTick(() => {
          this.$refs.modalForm.edit(record)
        })
      },
      myHandleCopyAdd(record) {
        this.formMode = 'add'
        this.showForm = true
        this.$nextTick(() => {
          this.$refs.modalForm.action = 'copyAdd'
          this.$refs.modalForm.edit(record)
        })
      },
      modalFormOk() {
        this.showForm = false
        this.loadData()
      },
      modalFormClose() {
        this.showForm = false
      },
      searchQuery() {
        this.loadData(1)
      },
      searchReset() {
        this.queryParam = {
          type: this.queryParam.type,
          subType: this.queryParam.subType
        }
        this.loadData(1)
      },
      myHandleDelete(record) {
        let that = this
        if(record.status === '0') {
          deleteAction(that.url.delete, {id: record.id}).then((res) => {
            if(res.code === 200){
              that.loadData(1)
            } else {
              that.$message.warning(res.data.message);
            }
          })
        } else {
          this.$message.warning("抱歉，只有未审核的单据才能删除，请先进行反审核！")
        }
      },
      batchDel: function () {
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning('请选择一条记录！')
        } else {
          let ids = ""
          for (let i = 0; i < this.selectedRowKeys.length; i++) {
            ids += this.selectedRowKeys[i] + ","
          }
          let that = this
          this.$confirm({
            title: "确认删除",
            content: "是否删除选中数据?",
            onOk: function () {
              that.loading = true
              deleteAction(that.url.deleteBatch, {ids: ids}).then((res) => {
                if(res.code === 200){
                  that.loadData()
                  that.onClearSelected()
                } else {
                  that.$message.warning(res.data.message)
                }
              }).finally(() => {
                that.loading = false
              })
            }
          })
        }
      },
      handleTransferToReplay() {
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning('请选择一条记录！')
          return
        }
        const record = this.dataSource.find(item => item.id === this.selectedRowKeys[0])
        if (record) {
          this.$router.push({
            path: '/plugins/stockCheck/stockCheckReplay',
            query: { linkNumber: record.number }
          })
        }
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>